<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-8">
                <div class="form-group">
                    <label for="txbxName">Name</label>
                    <input id="txbxName" type="text" class="form-control" [(ngModel)]="target.name" name="name" required />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label for="txbxSortOrder">Sort Order</label>
                    <input id="txbxSortOrder" type="number" class="form-control" [(ngModel)]="target.sortOrder" name="sortOrder" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-check" style="margin-bottom: 10px">
                    <input id="chkArchived" type="checkbox" class="form-check-input" [(ngModel)]="target.archived" name="archived" />
                    <label class="form-check-label" for="chkArchived">Archived</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
